import React from 'react';
import SubPage from '../components/SubPage';
import { subPages } from '../subpages';
import ServiceShowcase, { RevenueHeroMock } from '../components/ServiceShowcases';
import { useT } from '../i18n';

export default function RevenueGrowthPage() {
  const { lang } = useT();
  return (
    <SubPage
      data={subPages['restaurant-revenue-growth']}
      heroVisual={<RevenueHeroMock lang={lang} />}
      showcase={<ServiceShowcase slug="revenue-growth" lang={lang} />}
    />
  );
}
